module.exports = __webpack_public_path__ + "assets/pdf/transcript-en-training.a1ac529f.pdf";